import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({

})
export default class MonthItem  extends Vue {
    @Prop({ type: Object }) item!: calendar.DateItem;

    viewSchedule(item: calendar.CalendarItem) {
        if(item.id && item.id != null) {
            this.$emit('viewSchedule', item);
        }        
    }

    viewMore(item: calendar.DateItem) {
        this.$emit('viewMore', item);
    }
}